import { formatBlogDate } from "../utils/format";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

/** "OCTOBER 29, 2026 · 6 MIN READ" in small mono capitals, the way every post is dated. */
export const PostMeta = ({
  publishedAt,
  readingMinutes,
  className,
}: {
  publishedAt: string | null;
  readingMinutes: number;
  className?: string;
}) => (
  <p className={cn("font-mono text-[11px] font-medium tracking-[0.12em] text-muted-foreground uppercase", className)}>
    {publishedAt ? <time dateTime={publishedAt}>{formatBlogDate(publishedAt)}</time> : null}
    {publishedAt ? <span aria-hidden className="mx-2 opacity-50">•</span> : null}
    {m.blog_reading_minutes({ minutes: String(readingMinutes) })}
  </p>
);
